import * as React from 'react';
import { useRouter } from 'next/router';

import { Link } from '@blockworks/ui/legacy/link';
import { cn } from '@blockworks/ui/utils';

interface ITab {
    name: string;
    href: string;
    current?: boolean;
    count?: number;
}

type Props = {
    className?: string;
    // onChange?: (selectedTab: ITab) => void;
    tabs: ITab[];
    hideActive?: boolean;
};

const Tabs = (props: Props) => {
    const router = useRouter();
    const { tabs, hideActive } = props;
    const mappedTabs = tabs.map(value => {
        if (value.href === router.pathname) {
            value.current = true;
        } else {
            value.current = false;
        }
        return value;
    });

    return (
        <div className={props.className ?? 'border-b border-gray-200'}>
            <nav className="flex space-x-1 md:space-x-4" aria-label="Grants Tabs">
                {mappedTabs.map(
                    tab =>
                        (!hideActive || !tab.current) && (
                            <Link
                                key={tab.name}
                                href={tab.href}
                                className={cn(
                                    tab.current
                                        ? 'border-brand text-brand font-bold'
                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                    'flex whitespace-nowrap border-b py-3 px-0.5 text-sm lg:text-base font-medium',
                                )}
                                aria-current={tab.current ? 'page' : undefined}
                            >
                                {tab.name}
                                {tab.count ? (
                                    <span
                                        className={cn(
                                            tab.current ? 'bg-purple-100 text-brand' : 'bg-gray-100 text-gray-900',
                                            'ml-3 hidden rounded-full py-0.5 px-2.5 text-xs font-medium md:inline-block',
                                        )}
                                    >
                                        {tab.count}
                                    </span>
                                ) : null}
                            </Link>
                        ),
                )}
            </nav>
        </div>
    );
};

export default Tabs;
